
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class PsParaGrid extends Serenity.EntityGrid<PsParaRow, any> {
        protected getColumnsKey() { return PsParaColumns.columnsKey; }
        protected getDialogType() { return PsParaDialog; }
        protected getIdProperty() { return PsParaRow.idProperty; }
        protected getInsertPermission() { return PsParaRow.insertPermission; }
        protected getLocalTextPrefix() { return PsParaRow.localTextPrefix; }
        protected getService() { return PsParaService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = [];

            return buttons;
        }
        

        protected createSlickGrid() {
            this.slickGrid = super.createSlickGrid();

            new Serenity.AutoColumnWidthMixin({
                grid: this
            });

            return this.slickGrid;
        }
    }
}